var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faCalendarAlt, faEdit, faSave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, DatePicker, Icon, Row, Typography } from "antd";
import Form from "antd/lib/form/Form";
import moment from "moment";
import React from "react";
var EditDateRange = /** @class */ (function (_super) {
    __extends(EditDateRange, _super);
    function EditDateRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editClicked: false,
            edited: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if ((prevProps.options[0].initialValue !== _this.props.options[0].initialValue) ||
                (prevProps.options[1].initialValue !== _this.props.options[1].initialValue)) {
                _this.setState({
                    edited: false
                });
            }
        };
        _this.render = function () {
            var _a = _this.props, fieldKeys = _a.fieldKeys, options = _a.options, onChange = _a.onChange, placeholders = _a.placeholders, disabled = _a.disabled;
            var _b = _this.state, editClicked = _b.editClicked, edited = _b.edited;
            var _c = _this.props.form, getFieldDecorator = _c.getFieldDecorator, getFieldValue = _c.getFieldValue, getFieldError = _c.getFieldError;
            var hasError = getFieldError(fieldKeys[0]) || getFieldError(fieldKeys[1]);
            return (React.createElement(Row, null,
                React.createElement(Col, { xxl: 22, xl: 22, lg: 22, md: 22, sm: 24, xs: 24 }, editClicked ?
                    React.createElement(Row, { gutter: 8, className: "no-margin" },
                        React.createElement(Col, { xxl: 12, xl: 12, lg: 12, md: 24, sm: 24, xs: 24 },
                            React.createElement(Form.Item, null, getFieldDecorator(fieldKeys[0], options[0])(React.createElement(DatePicker, { className: "small-date-picker", showTime: true, placeholder: placeholders[0], style: { width: "100%" }, format: "MM/DD/YYYY hh:mm A", suffixIcon: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }); } }), allowClear: false })))),
                        React.createElement(Col, { xxl: 12, xl: 12, lg: 12, md: 24, sm: 24, xs: 24 },
                            React.createElement(Form.Item, null, getFieldDecorator(fieldKeys[1], options[1])(React.createElement(DatePicker, { disabledDate: function (current) { return current && getFieldValue(fieldKeys[0]) ? current < getFieldValue(fieldKeys[0]) : false; }, className: "small-date-picker", showTime: true, placeholder: placeholders[1], style: { width: "100%" }, format: "MM/DD/YYYY hh:mm A", suffixIcon: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }); } }), allowClear: false }))))) :
                    React.createElement(Typography.Paragraph, { ellipsis: true }, edited ?
                        "".concat(moment(getFieldValue(fieldKeys[0])).calendar(), " - ").concat(getFieldValue(fieldKeys[1]) ? moment(getFieldValue(fieldKeys[1])).calendar() : "N/A") || "N/A" :
                        "".concat(moment(options[0].initialValue).calendar(), " - ").concat(options[1].initialValue ? moment(options[1].initialValue).calendar() : "N/A") || "N/A")),
                React.createElement(Col, { xxl: 2, xl: 2, lg: 2, md: 2, sm: 24, xs: 24 }, editClicked ?
                    React.createElement(Form.Item, null,
                        React.createElement(Icon, { className: "margin-left-xs ".concat(disabled || hasError ? "color-gray-5" : "color-blue-5 cursor-pointer", " font-size-lg"), component: function () { return React.createElement(FontAwesomeIcon, { icon: faSave }); }, onClick: function () {
                                if (!disabled && !hasError) {
                                    _this.setState({ editClicked: false });
                                    var values = [getFieldValue(fieldKeys[0]), getFieldValue(fieldKeys[1])];
                                    if ((values[0] !== options[0].initialValue) || (values[1] !== options[1].initialValue)) {
                                        onChange([moment(values[0]), moment(values[1])]);
                                    }
                                }
                            } })) :
                    React.createElement(Icon, { className: "margin-left-xs ".concat(disabled ? "color-gray-5" : "color-blue-5 cursor-pointer", " font-size-lg"), component: function () { return React.createElement(FontAwesomeIcon, { icon: faEdit }); }, onClick: function () {
                            if (!disabled) {
                                _this.setState({ editClicked: true });
                            }
                        } }))));
        };
        return _this;
    }
    return EditDateRange;
}(React.Component));
export default EditDateRange;
//# sourceMappingURL=edit-date-range.js.map